import { SET_TABLE_DATA } from "../../constants/dataTableConstants";

export const setTableData = (items, paginate, sumAmount = [],sumAmountFinal
=[]) => {
  return {
    type: SET_TABLE_DATA,
    items,
    paginate,
    sumAmount,
    sumAmountFinal

  };
};
